<span
class="{{className}}"
matBadge={{content}}
[hidden]="isHidden"
>
</span>